'use strict';

var defer = require('pull-defer');

var pull = require('pull-stream/pull');

var error = require('pull-stream/sources/error');

var values = require('pull-stream/sources/values');

var filter = require('pull-stream/throughs/filter');

var map = require('pull-stream/throughs/map');

var cat = require('pull-cat');

var Bucket = require('hamt-sharding/src/bucket');

var DirSharded = require('ipfs-unixfs-importer/src/importer/dir-sharded');

var waterfall = require('async/waterfall'); // Logic to export a unixfs directory.


module.exports = shardedDirExporter;

function shardedDirExporter(cid, node, name, path, pathRest, resolve, size, dag, parent, depth, options) {
  var dir;

  if (!parent || parent.path !== path) {
    dir = {
      name: name,
      depth: depth,
      path: path,
      multihash: cid.buffer,
      size: node.size,
      type: 'dir'
    };
  } // we are at the max depth so no need to descend into children


  if (options.maxDepth && options.maxDepth <= depth) {
    return values([dir]);
  }

  if (!pathRest.length) {
    // return all children
    var streams = [pull(values(node.links), map(function (link) {
      // remove the link prefix (2 chars for the bucket index)
      var entryName = link.name.substring(2);
      var entryPath = entryName ? path + '/' + entryName : path;
      return {
        depth: entryName ? depth + 1 : depth,
        name: entryName,
        path: entryPath,
        multihash: link.cid.buffer,
        pathRest: entryName ? pathRest.slice(1) : pathRest,
        parent: dir || parent
      };
    }), resolve)]; // place dir before if not specifying subtree

    streams.unshift(values([dir]));
    return cat(streams);
  }

  var deferred = defer.source();
  var targetFile = pathRest[0]; // recreate our level of the HAMT so we can load only the subshard in pathRest

  waterfall([function (cb) {
    if (!options.rootBucket) {
      options.rootBucket = new Bucket({
        hashFn: DirSharded.hashFn
      });
      options.hamtDepth = 1;
      return addLinksToHamtBucket(node.links, options.rootBucket, options.rootBucket, cb);
    }

    return addLinksToHamtBucket(node.links, options.lastBucket, options.rootBucket, cb);
  }, function (cb) {
    return findPosition(targetFile, options.rootBucket, cb);
  }, function (position, cb) {
    var prefix = toPrefix(position.pos);
    var bucketPath = toBucketPath(position);

    if (bucketPath.length > options.hamtDepth) {
      options.lastBucket = bucketPath[options.hamtDepth];
      prefix = toPrefix(options.lastBucket._posAtParent);
    }

    var streams = [pull(values(node.links), map(function (link) {
      var entryPrefix = link.name.substring(0, 2);
      var entryName = link.name.substring(2);
      var entryPath = entryName ? path + '/' + entryName : path;

      if (entryPrefix !== prefix) {
        // not the entry or subshard we're looking for
        return false;
      }

      if (entryName && entryName !== targetFile) {
        // not the entry we're looking for
        return false;
      }

      if (!entryName) {
        // we are doing to descend into a subshard
        options.hamtDepth++;
      } else {
        // we've found the node we are looking for, remove the context
        // so we don't affect further hamt traversals
        delete options.rootBucket;
        delete options.lastBucket;
        delete options.hamtDepth;
      }

      return {
        depth: entryName ? depth + 1 : depth,
        name: entryName,
        path: entryPath,
        multihash: link.cid.buffer,
        pathRest: entryName ? pathRest.slice(1) : pathRest,
        parent: dir || parent
      };
    }), filter(Boolean), resolve)];

    if (options.fullPath) {
      streams.unshift(values([dir]));
    }

    cb(null, streams);
  }], function (err, streams) {
    if (err) {
      return deferred.resolve(error(err));
    }

    deferred.resolve(cat(streams));
  });
  return deferred;
}

var addLinksToHamtBucket = function addLinksToHamtBucket(links, bucket, rootBucket, callback) {
  Promise.all(links.map(function (link) {
    if (link.name.length === 2) {
      var pos = parseInt(link.name, 16);
      return bucket._putObjectAt(pos, new Bucket({
        hashFn: DirSharded.hashFn
      }, bucket, pos));
    }

    return rootBucket.put(link.name.substring(2), true);
  })).catch(function (err) {
    callback(err);
    callback = null;
  }).then(function () {
    return callback && callback();
  });
};

var toPrefix = function toPrefix(position) {
  return position.toString('16').toUpperCase().padStart(2, '0').substring(0, 2);
};

var findPosition = function findPosition(file, bucket, cb) {
  bucket._findNewBucketAndPos(file).catch(function (err) {
    cb(err);
    cb = null;
  }).then(function (position) {
    if (!cb) {
      // would have errored in catch block above
      return;
    }

    cb(null, position);
  });
};

var toBucketPath = function toBucketPath(position) {
  var bucket = position.bucket;
  var path = [];

  while (bucket._parent) {
    path.push(bucket);
    bucket = bucket._parent;
  }

  path.push(bucket);
  return path.reverse();
};